<script lang="ts">
    import {CurrentAuthService, WalkerService} from 'shared/services';
    import {getInjector, getLocalization} from 'src/core';

    const localize = getLocalization();
    const currentAuthService = getInjector().getByClass(CurrentAuthService);
    const walker = getInjector().getByClass(WalkerService);
    const currentAuth$ = currentAuthService.currentAuth$();

    $: isAuthenticated = $currentAuth$.role.includes('ROLE_EXTERNALLY_AUTHENTICATED');

    function redirect() {
        walker.newPage('/login/oauth2/code/mojeid', {redirect: window.location.href});
    }
</script>

<div class="login-system login-system-mojeid">
    {#if isAuthenticated}
        <div>
            MojeID {$currentAuth$.activeUser.text}
        </div>
    {:else}
        <button class="btn btn-primary btn-block btn-mojeid-login"
                data-qa="mojeid-login-button"
                on:click={redirect}>
            {localize(/* @kp-localization login.prihlaseniPomociOpenId */ 'login.prihlaseniPomociOpenId')}
        </button>
    {/if}
</div>

<style lang="less">
    .btn-mojeid-login {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
    }

    .btn-mojeid-login:hover,
    .btn-mojeid-login:focus {
        color: #fff;
        background-color: #23272b;
        border-color: #1d2124;
    }

    .btn-mojeid-login:active {
        color: #fff;
        background-color: #1d2124;
        border-color: #171a1d;
    }
</style>